import { useState } from "react";
import {
  apiGetUserByToken,
  apiGetCurrentSession,
  apiLogin,
  apiLogout,
  apiSignup,
  apiPatchUserByToken,
  apiCreateToken,
  apiUndoImpersonate
} from "../accountApiActions";
import isUndefined from "lodash/isUndefined";

export default function useAccount() {
  return () => {
    const [account, setAccount] = useState({});
    const [isLoggedIn, setLoggedIn] = useState(false);

    const getCurrentSession = () => {
      return apiGetCurrentSession()
        .then(({ data }) => {
          setAccount(data);
          setLoggedIn(true);
        })
        .catch(_ => {
          setAccount({});
          setLoggedIn(false);
          localStorage.clear();
        });
    };

    const login = values =>
      apiLogin(values).then(({ data }) => {
        setAccount(data);
        setLoggedIn(true);
        localStorage.setItem("authToken", data.userKey);
      });

    const signout = () => {
      return apiLogout().then(_ => {
        setAccount({});
        setLoggedIn(false);
        localStorage.clear();
      });
    };

    const signup = values =>
      apiSignup(values).then(({ data }) => {
        setAccount(data);
        setLoggedIn(true);
      });

    const getUserByToken = (tokenId, email) => {
      return apiGetUserByToken(
        encodeURIComponent(tokenId),
        encodeURIComponent(email)
      );
    };

    const sendPassWordReset = email => {
      return apiCreateToken({
        email,
        type: "Password"
      });
    };

    const undoImpersonate = () => {
      return apiUndoImpersonate();
    };

    const patchUserByToken = (tokenId, model) => {
      return apiPatchUserByToken(tokenId, model);
    };

    const hasRole = role => {
      const roles = account.roles || [];
      return roles.includes(role);
    };

    const isImpersonating = () => {
      return isUndefined(account.impersonator);
    };

    return {
      state: {
        account,
        isLoggedIn
      },
      getCurrentSession,
      login,
      signup,
      signout,
      getUserByToken,
      patchUserByToken,
      hasRole,
      isImpersonating,
      undoImpersonate,
      sendPassWordReset
    };
  };
}
